// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"610bc887","764":"9062b16b"}[chunkId] + ".chunk.js";
};